import React, { useState } from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMobileAppsGroupedStatsApi } from '../../../../hooks/api/mobile-apps-apis';
import useHelpers from '../../../../hooks/context/useHelpers';
import HelperMethods from '../../../../services/exports/HelperMethods';

function RestaurantDirectory({ dateRangeFilter }) {
  const { t } = useTranslation(null, { keyPrefix: 'Views:Dashboard:ServiceProvider:RestaurantDirectory' });
  const { formatCurrency } = useHelpers();
  const [params, setParams] = useState({});
  const { data, isFetching } = useMobileAppsGroupedStatsApi({ ...dateRangeFilter, ...params });
  const pagination = {
    current: data?.current_page,
    defaultCurrent: 1,
    pageSize: data?.per_page,
    defaultPageSize: 5,
    showSizeChanger: false,
    total: data?.total,
  };
  const columns = [
    {
      title: t('name.label'),
      dataIndex: 'name',
      sorter: true,
    },
    { title: t('mobile_app_released_at.label'), dataIndex: 'mobile_app_released_at', sorter: true },
    { title: t('mobile_app_downloads.label'), dataIndex: 'mobile_app_downloads', sorter: true },
    {
      title: t('mobile_app_gmv.label'),
      dataIndex: 'mobile_app_gmv',
      sorter: true,
      render: (value) => (value ? formatCurrency(value) : null),
    },
    {
      title: t('mobile_app_orders_count.label'),
      dataIndex: 'mobile_app_orders_count',
      sorter: true,
      render: (value) => value || null,
    },
    {
      title: t('mobile_app_average_order_value.label'),
      dataIndex: 'mobile_app_average_order_value',
      sorter: true,
      render: (value) => (value ? formatCurrency(value) : null),
    },
    {
      title: t('mobile_app_gmv_percentage.label'),
      dataIndex: 'mobile_app_gmv_percentage',
      sorter: true,
      render: (value) => !!value && HelperMethods.formatPercentage(value),
    },
  ];
  const onChange = (pagination, filters, sorter) => {
    const sortOrder = {
      ascend: 'asc',
      descend: 'desc',
    }[sorter?.order];

    setParams((prev) => ({
      ...prev,
      sort_by: sorter?.field,
      sort_order: sortOrder,
      page: pagination?.current,
    }));
  };

  return (
    <>
      <h5>{t('title')}</h5>
      <Table
        className="rounded-xl shadow-card bg-white overflow-hidden"
        rowKey="id"
        columns={columns}
        dataSource={data?.data}
        loading={isFetching}
        pagination={pagination}
        onChange={onChange}
      />
    </>
  );
}

export default RestaurantDirectory;
